import { render, staticRenderFns } from "./InvoicesBatchReport.vue?vue&type=template&id=ed3be680"
import script from "./InvoicesBatchReport.vue?vue&type=script&lang=js"
export * from "./InvoicesBatchReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports